import React, { useState } from "react";
import mealsImage from "../../assets/mel.jpg";
import classes from "./Header.module.css";
import HeaderCartButton from "./HeaderCartButton";
const Header = (props) => {


 

  return (
    <React.Fragment>
      <header className={classes.header}>
        <h1>MS Cafe</h1>

        <HeaderCartButton onClick={props.onShowCart} />
      </header>
      <div className={classes["main-image"]}>
        <img src={mealsImage} alt="food-img" />
      </div>
    </React.Fragment>
  );
};

export default Header;
